import { render } from "./PrescriptionDetails.vue?vue&type=template&id=2910902c&scoped=true"
import script from "./PrescriptionDetails.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetails.vue?vue&type=script&lang=js"

import "./PrescriptionDetails.vue?vue&type=style&index=0&id=2910902c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2910902c"]])

export default __exports__